export default [
  // Gratis
  {
    path: "/video",
    name: "video",
    component: () => import("@/views/menu/video"),
    meta: {
      pageTitle: "Video",
      breadcrumb: [
        {
          text: "Video",
          active: true,
        },
      ],
    },
  },

  {
    path: "/video/list-video/:id",
    name: "list-video",
    component: () => import("@/views/menu/video/list-video"),
    meta: {
      pageTitle: "Video",
      breadcrumb: [
        {
          text: "Video",
          active: false,
          to: {
            name: "video",
          },
        },
        {
          text: "List Video",
          active: true,
        },
      ],
    },
  },

  {
    path: "/video-detail/:id/:detailId",
    name: "detail-video",
    component: () => import("@/views/menu/video/detail"),
    meta: {
      pageTitle: "Video",
      breadcrumb: [
        {
          text: "Video",
          active: false,
          to: {path: "/video"},
        },
        {
          text: "List Video",
          active: true,
        },
      ],
    },
  },

  // Gratis
  {
    path: "/live",
    name: "live",
    component: () => import("@/views/menu/live/index.vue"),
  },

  {
    path: "/live/list-live/:id",
    name: "list-live",
    component: () => import("@/views/menu/live/list-live"),
    meta: {
      pageTitle: "Live",
      breadcrumb: [
        {
          text: "Live",
          active: false,
          to: {
            name: "live",
          },
        },
        {
          text: "List Live",
          active: true,
        },
      ],
    },
  },

  {
    path: "/live/:id",
    name: "live",
    component: () => import("@/views/menu/live/detail.vue"),
  },
];
